const servicesEn = [
    {
      icon: "🧾",
      title: "Financial Audit",
      details: [
        "Statutory audits",
        "Due diligence",
        "Consolidated / group reporting"
      ],
      detailData: {
        title: "Financial Audit",
        subtitle: "Focus on the Offer / Team / Skills / Certifications",
        sections: [
          {
            title: "OFFER",
            image: "/images/offre.png",
            points: [
              "Participation in legal and contractual audits",
              "Integration into remote audit teams, participation in audit activities",
              "Planning",
              "Interim reviews",
              "Limited reviews",
              "Due diligence validation",
              "Supervision",
              "Closing and assessments finalization",
              "Supporting the team or working directly with clients",
              "Ability to use a dedicated email address"
            ]
          },
          {
            title: "TEAM",
            image: "/images/equipe.png",
            points: [
              "Provision of highly qualified financial auditors",
              "Chartered Accountants",
              "IFRS-certified",
              "Trilingual",
              "All levels of seniority (from junior to very experienced)"
            ]
          },
          {
            title: "SKILLS",
            image: "/images/competence.png",
            points: [
              "Covering the most important economic sectors",
              "Financial industry",
              "Pharmaceuticals",
              "And various types of assignments",
              "Consolidated financial statements and group reporting audit",
              "Organizational audit",
              "Projects audit"
            ]
          },
          {
            title: "CERTIFICATIONS",
            image: "/images/certificate.png",
            points: [
              "Chartered Accountant",
              "Diploma in Accounting, Control and Audit (CCA Master)",
              "IFRS certification",
              "PMP",
              "FRM",
              "CISA",
              "GRI certification",
              "COBIT",
              "ITIL"
            ]
          }
        ]
      }
    },
    {
      icon: "🖥️",
      title: "IT Audit",
      details: [
        "General IT controls (ITGC)",
        "SOC 1 / SOC 2 Reports",
        "Cybersecurity and regulatory compliance"
      ],
      detailData: {
        title: "IT Audit",
        subtitle: "Focus on the Offer / Team / Skills / Certifications",
        sections: [
          {
            title: "OFFER",
            image: "/images/offre.png",
            points: [
              "Client-specific procedures",
              "ITGC",
              "ITAC",
              "SOC report assessment",
              "Third party assurance",
              "SOC 1 (Internal Control)",
              "SOC 2 (Security)",
              "Operational SOC"
            ]
          },
          {
            title: "TEAM",
            image: "/images/equipe.png",
            points: [
              "Staff members with specific background in:",
              "Information technology",
              "Finance",
              "Cybersecurity",
              "All levels of seniority (from junior to very experienced)"
            ]
          },
          {
            title: "SKILLS",
            image: "/images/competence.png",
            points: [
              "General IT controls",
              "Automated controls",
              "Third Party Assurance"
            ]
          },
          {
            title: "CERTIFICATIONS",
            image: "/images/certificate.png",
            points: [
              "IT specialist accreditation",
              "ITIL V4 Foundation",
              "COBIT",
              "CISA",
              "ISO 27001 LL/LA",
              "Certified Ethical Hacker"
            ]
          }
        ]
      }
    },
    {
      icon: "🛠️",
      title: "Accounting & Operational Support",
      details: [
        "Billing",
        "Management control",
        "Payroll",
        "Financial reporting"
      ],
      detailData: {
        title: "Accounting & Operational Support",
        subtitle: "Focus on the Offer / Team / Skills / Certifications",
        sections: [
          {
            title: "OFFER",
            image: "/images/offre.png",
            points: [
              "Assistance in billing, controlling, accounts payable",
              "Assistance in the maintaining of HR basis",
              "Supporting in the periodic financial closing (monthly, yearly, other)",
              "Performing controls to ensure the integrity of the company’s financial data",
              "Preparing executive reports",
              "Managing the financial control processes, including reviewing and analyzing quarterly figures and disclosures",
              "Providing stakeholders with accurate and complete financial information"
            ]
          },
          {
            title: "TEAM",
            image: "/images/equipe.png",
            points: [
              "Chartered Accountants",
              "Finance graduates",
              "Accounting graduates",
              "Administration degrees",
              "Payroll specialists",
              "Trilingual",
              "All levels of seniority (from junior to very experienced)"
            ]
          },
          {
            title: "SKILLS",
            image: "/images/competence.png",
            points: [
              "Excellent Excel and PowerPoint skills",
              "Reporting tools like Planning Analytics",
              "Data processing skills",
              "Communication skills"
            ]
          },
          {
            title: "CERTIFICATIONS",
            image: "/images/certificate.png",
            points: [
              "Chartered Accountant",
              "Diploma in Accounting, Control and Audit (CCA Master)",
              "Master degrees in Finance and/or Administration"
            ]
          }
        ]
      }
    }
  ];
  
  export default servicesEn;
  